import { render, staticRenderFns } from "./Upholsterylist.vue?vue&type=template&id=5dc1615f&scoped=true"
import script from "./Upholsterylist.vue?vue&type=script&lang=js"
export * from "./Upholsterylist.vue?vue&type=script&lang=js"
import style0 from "./Upholsterylist.vue?vue&type=style&index=0&id=5dc1615f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1615f",
  null
  
)

export default component.exports